import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const FETCH_SUBSCRIPTION_TRANSACTIONS_LIST_API_ID =
  'DASHBOARD/FETCH_SUBSCRIPTION_TRANSACTIONS_LIST_API';

// Unscoped - lists PaymentTransaction rows across every subscription plan,
// optionally filtered by subscription_id/environment query params (see
// AdminSubscriptionController.GetAllTransactions). Unlike the nested
// apiCalls/subscriptions/transactions.ts, this isn't tied to one plan's id.
const apiCall = createApiCall(
  FETCH_SUBSCRIPTION_TRANSACTIONS_LIST_API_ID,
  (params: Record<string, any>) => ({
    endpoint: generateEndpoint({
      host: `/api/admin/subscriptions/transactions`,
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
